module.exports = __webpack_public_path__ + "img/1.42254d12.png";